import {Fragment, useState} from "react";
import {TableComponent} from "../Global/AgGridTableComponent";
import {Dialog, DialogContent} from "@mui/material";
import {InformationUnitComponet} from "./InformationUnit";

const VALUE_DIALOG_INIT={
      statusDialog: false,
      dataDialog: null
}

function DialogInfoUnit({openDialog= false, handlingCloseDialog=null, dataRow=null}){
      return(
          <Dialog scroll="body" open={openDialog} onClose={handlingCloseDialog}>
                <InformationUnitComponet dataUnit={dataRow} />
          </Dialog>
      );
}

export function InformationShipComponent(){

      const [showDialog, setShowDialog] = useState(VALUE_DIALOG_INIT)

      // Datos de ejemplo para la tabla
      const rowData = [
            { id: 1, status: 'Aceptada', taller: 'Taller 1', date_in: '2023-05-01', chofer: 'Juan', unidad: 'Unidad A', descripcion:'En proceso' },
            { id: 2, status: 'Aceptada', taller: 'Taller 3', date_in: '2023-08-15', chofer: 'Carlos', unidad: 'Unidad B', descripcion:'En proceso' },
      ];
  
      // Columnas de la tabla
      const columnDefs = [
            { headerName: 'ID', field: 'id', flex: 1 },
            { headerName: 'Status', field: 'status', flex: 1 },
            { headerName: 'Taller', field: 'taller', flex: 1 },
            { headerName: 'Fecha entrada', field: 'date_in', flex: 1 },
            { headerName: 'Chofer que reporto', field: 'chofer', flex: 1 },
            { headerName: 'Unidad reportada', field: 'unidad', flex: 1 },
            { headerName: 'Descripcion', field: 'descripcion', flex: 1 },
      ];
  
      return (
            <Fragment>
                  <TableComponent
                      titleTable="Unidades en la nave"
                      columnsTable={columnDefs}
                      rowsTable={rowData}
                      handlingDoubleClick={(event)=>setShowDialog(()=>({dataDialog: event.data, statusDialog:true}))}
                  />

                  {
                        showDialog.statusDialog?
                            <DialogInfoUnit
                                openDialog={showDialog.statusDialog}
                                dataRow={showDialog.dataDialog}
                                handlingCloseDialog={()=>setShowDialog(()=>(VALUE_DIALOG_INIT))}
                            />:null
                  }

            </Fragment>
      );
}